// Keep initialization in connectedCallback so section rendering and editor reloads work.
class ArtemisCountdown extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    clearTimeout(this.restartTimeout);
  }

  init() {
    this.disconnectedCallback();
    this.countdownType = this.dataset.countdownType || 'fixed';

    if (this.countdownType === 'daily') {
      const dailyEndTime = this.dataset.dailyEndTime || '23:59:59';
      const validTime = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(dailyEndTime);
      this.targetDate = NaN;
      if (validTime) {
        const [hours, minutes, seconds] = dailyEndTime.split(':').map(Number);
        const now = new Date();
        const target = new Date(now);
        target.setHours(hours, minutes, seconds, 0);
        if (target.getTime() < now.getTime()) target.setDate(target.getDate() + 1);
        this.targetDate = target.getTime();
      }
    } else {
      this.targetDate = new Date(this.dataset.targetDate).getTime();
    }

    if (!Number.isFinite(this.targetDate)) {
      this.style.display = 'none';
      return;
    }

    this.style.display = 'flex';
    if (this.update()) this.interval = setInterval(() => this.update(), 1000);
  }

  update() {
    const distance = this.targetDate - Date.now();
    if (distance < 0) {
      clearInterval(this.interval);
      this.style.display = 'none';
      if (this.countdownType === 'daily') {
        // Preserve the original three-minute pause before the next daily countdown.
        this.restartTimeout = setTimeout(() => {
          if (this.isConnected) this.init();
        }, 3 * 60 * 1000);
      }
      return false;
    }

    const values = {
      days: Math.floor(distance / 86400000),
      hours: Math.floor((distance % 86400000) / 3600000),
      minutes: Math.floor((distance % 3600000) / 60000),
      seconds: Math.floor((distance % 60000) / 1000),
    };
    for (const [unit, value] of Object.entries(values)) {
      const element = this.querySelector(`[data-unit="${unit}"]`);
      const formattedValue = String(value).padStart(2, '0');
      if (element && element.textContent !== formattedValue) element.textContent = formattedValue;
    }
    return true;
  }
}

if (!customElements.get('simple-countdown-component')) {
  customElements.define('simple-countdown-component', ArtemisCountdown);
}
